import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import './Cart.scss';
import bag from './../../assets/bag.svg';
import useCartStore from './../../store/cartStore'; 
import useUserStore from '../../store/userStore'; 
import { useLoadingStore } from '../../store/loadingStore';
import useToastStore from '../../store/toastStore';
import { CartItemDTO } from '../../types/Cart';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { mediaUrl } from '../../helper/Api';
const Cart = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const {  isAuthenticated,user} = useUserStore(); 
  const {setLoading} = useLoadingStore();
  const { cart, removeFromCart,getCart,updateCart } = useCartStore();
  const {showToast} = useToastStore();
  const [editingItem, setEditingItem] = useState<{id: string, quantity: number} | null>(null);

  const sum = cart.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  const totalSum = sum ;

  const handleRemoveItem = async (id: string) => {
    setLoading(true);
    try{
      await removeFromCart(id);
      showToast('Added product to cart!','success')
    }
    catch(error){
      showToast('Error product to cart!','error')
    }
    setLoading(false);
  };

  const handleUpdateItem = async (item : CartItemDTO) => {
    if (!editingItem || editingItem.id !== item.id) return;
    setLoading(true);
    try{
      await updateCart({...item, quantity: editingItem.quantity});
      showToast('Added product to cart!','success')
    }
    catch(error){
      showToast('Error product to cart!','error')
    }
    setLoading(false);
  }
  

  const handlePlaceOrder = () => {
    navigate(`/checkout`);
    setIsOpen(false)
  }
  useEffect(()=>{
    const fetchCart = async()=>{
      await getCart();
    }
    fetchCart();
  },[user,getCart])

  
  return (
    <>

      <div className="cart-button" onClick={() => setIsOpen(true)}>
        <img src={bag} alt="Cart" />
        <span className="cart-count">({cart.length})</span>
      </div>


      {isOpen && (
        <div className="cart-sidebar">
      
          <div className="cart-header">
            <h2>Το καλάθι μου (Προϊόντα : {cart.length})</h2>
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              Επιστροφή <FontAwesomeIcon className='return' icon={faChevronRight} />
            </button>
          </div>

   
          <div className="cart-items">
            {cart.length > 0 ? (
              cart.map((item) => (
                <div key={item.sku} className="cart-item">
                    <button
                    className="remove-btn"
                    onClick={() => handleRemoveItem(item?.id)}
                    >
                    <FontAwesomeIcon icon={faCircleXmark} />
                  </button>
                    <div className='product'>
                        <img
                        src={mediaUrl(item.image)}
                        alt={item.name}
                        className="product-banner"
                        />
                        <div className="product-details">
                            <div className="product-title">{item.name}</div>
                            <div className="product-sku">SKU: {item.sku}</div>
                        </div>
                        <div className="productPrices">
                            <div className="product-price">
                                {item?.price} €
                            </div>
                            <div className="product-quantity">Ποσότητα:
                                { ' ' + item?.quantity}
                            </div>
                        </div>
                    </div>
                </div>
              ))
            ) : (
              <p className="empty-cart">Το καλάθι σας είναι άδειο.</p>
            )}
          </div>

      
          <div className="cart-footer">
            <div className='cf-title'>ΣΥΝΟΛΟ</div>
            {/* <div className='subtotals'>
                <div className='sub'>
                Subtotal: <span>{sum.toFixed(2)} €</span>
                </div>
         
            </div> */}
            <div className="total-sum">
              Σύνολο: <span>{totalSum.toFixed(2)} €</span>
            </div>
            <button 
            onClick={handlePlaceOrder}
            disabled={!isAuthenticated}
            className="place-order-btn">Ολοκλήρωση Αγοράς</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Cart;